import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, vShow as _vShow, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a151219e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex row colunaDados" }
const _hoisted_2 = { class: "form-label col-12 col-sm-12 col-md-12 col-lg-2 col-xl-1 col-xxl-1" }
const _hoisted_3 = { class: "form-label col-12 col-sm-12 col-md-12 col-lg-5 col-xl-3 col-xxl-3" }
const _hoisted_4 = { class: "form-label col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 col-xxl-2" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "form-label col-12 col-sm-12 col-md-12 col-lg-3 col-xl-2 col-xxl-2" }
const _hoisted_7 = ["value"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_9 = {
  class: "d-flex prontuario",
  style: { 'height': 'auto' }
}
const _hoisted_10 = { class: "d-flex flex-column" }
const _hoisted_11 = {
  key: 0,
  class: "d-flex informacoesProntuarios scrollspy-example w-100"
}
const _hoisted_12 = {
  class: "me-0 h-50 tabelaInformacoes w-100",
  style: { 'minHeight': '200px' }
}
const _hoisted_13 = { class: "table mb-0" }
const _hoisted_14 = { class: "linhaCabecalho" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = ["id", "onClick", "onKeyup", "tabindex"]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 2 }
const _hoisted_20 = ["tabindex"]
const _hoisted_21 = { key: 1 }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, "Nenhum prontuário encontrado")
], -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = {
  key: 1,
  class: ""
}
const _hoisted_25 = {
  key: 2,
  class: "me-0 scrollspy-example h-50 informacoesDetalhadas"
}
const _hoisted_26 = { class: "d-flex flex-direction-row justify-content-between" }
const _hoisted_27 = { class: "form-label col-sm-5 col-md-5 col-5" }
const _hoisted_28 = { class: "form-label col-sm-5 col-md-5 col-5" }
const _hoisted_29 = ["value"]
const _hoisted_30 = {
  key: 1,
  class: "form-control",
  type: "text",
  disabled: "",
  value: ''
}
const _hoisted_31 = { class: "form-label col-sm-12 col-md-12 col-12" }
const _hoisted_32 = ["value"]
const _hoisted_33 = { class: "camposProntuario me-0" }
const _hoisted_34 = { class: "nav nav-tabs abas" }
const _hoisted_35 = { class: "nav-item" }
const _hoisted_36 = { class: "nav-item" }
const _hoisted_37 = { class: "nav-item" }
const _hoisted_38 = { class: "nav-item" }
const _hoisted_39 = { class: "nav-item" }
const _hoisted_40 = { class: "nav-item" }
const _hoisted_41 = {
  key: 1,
  class: "col-sm-12 col-md-12 form-label h-auto"
}
const _hoisted_42 = {
  key: 2,
  class: "col-sm-12 col-md-12 form-label h-auto"
}
const _hoisted_43 = {
  key: 3,
  class: "col-sm-12 col-md-12 form-label h-auto"
}
const _hoisted_44 = {
  key: 4,
  class: "col-sm-12 col-md-12 form-label h-auto"
}
const _hoisted_45 = {
  key: 5,
  class: "col-sm-12 col-md-12 form-label h-auto"
}
const _hoisted_46 = { class: "receitasPequena mb-5" }
const _hoisted_47 = { class: "col-sm-5 col-md-5 form-label" }
const _hoisted_48 = { class: "nav nav-tabs" }
const _hoisted_49 = { class: "nav-item" }
const _hoisted_50 = { class: "nav-link active" }
const _hoisted_51 = { class: "col-sm-5 col-md-5 form-label" }
const _hoisted_52 = { class: "nav nav-tabs" }
const _hoisted_53 = { class: "nav-item" }
const _hoisted_54 = { class: "nav-link active" }
const _hoisted_55 = { class: "modal-footer px-0 pb-0 mt-4" }

import Paciente from '@/model/Paciente';
import PacienteProntuario from '@/model/PacienteProntuario';
import { store } from '@/store';
import moment from 'moment';
import { onMounted, reactive, computed } from 'vue';
import ModalDorape from './ModalDorape.vue';
import Profissional from '@/model/Profissional';
import Convenio from '@/model/Convenio';
import services from '@/services';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProntuarioComp',
  props: ['retornaDataBR', 'mostrarModal', 'prontuario', 'agendaLancar', 'historico', 'lstProntuario', 'config'],
  emits: ['fecharProntuario'],
  setup(__props, { emit: emits }) {

const props = __props;



const state = reactive({
    linhas: Array<string>('id', 'nome'),
    colunas: Array<string>('Código', 'Nome'),
    linhasAux: Array<string>('data', 'profissional'),
    colunasAux: Array<string>('Data', 'Profissional'),

    paciente: Object() as Paciente,
    prontuario: {
        id: Number(),
        paciente: Object() as Paciente,
        profissional: Object() as Profissional,
        idAtendimento: Number(),
        data: new Date(),
        hora: String(),
        usuario: String(),
        tipo: String(),
        hda: String(),
        hdaEnfermagem: String(),
        diagnostico: String(),
        exameFisico: String(),
        receita: String(),
        receitaEspecial: String(),
        lancouTelaPadrao: String(),
        idAtendimentoEv: Number(),
    },
    agendaLancar: {
        id: Number(),
        dtInclusao: new Date(),
        dtAgenda: new Date(),
        hrInclusao: new Date().toLocaleTimeString(),
        hrAgenda: String(),
        hrChegada: null,
        usuario: String(),
        usuarioUpdate: String(),
        status: String(),
        convenio: Object() as Convenio,
        profissional: Object() as Profissional,
        paciente: Object() as Paciente,
        idResumo: Number(),
        idAgendaPrincipal: Number(),
        idAtendimento: Number(),
        ordemChegada: Number(),
        whatsConfirmacao: String(),
        nomePaciente: String(),
        celular: String(),
        telefone: String(),
        idCliente: Number(),
        statusDescricao: String(),
        idPaciente: Number()
    },

    mostrarModal: Boolean(),
    campoUnico: Boolean(true),
    aguarde: Boolean(),
    telaPequena: Boolean(true),

    hdaMedico: "HDA Médico",
    hdaEnfermagem: "HDA Enfermagem",
    exameFisico: "Exame Físico",
    diagnostico: "Diagnóstico",
    receita: "Receita",
    receitaEspecial: "Receita Especial",

    numeroPagina: Number(0),
    linhaFocada: Number(0),
});

function modalResultProntuarios() {
    // document.querySelector('html')?.classList.remove("desligarOverflow");
    state.mostrarModal = false;
    emits('fecharProntuario');
}

function trocarPagina(pPagina: number) {
    state.numeroPagina = pPagina;
}

const config = computed(() => {
    return store.getters.getConfig;
});

function tamanho() {
    setInterval(() => {
        (window.innerWidth <= 992) ? state.telaPequena = true : state.telaPequena = false;
        // (window.innerWidth <= 768) ? state.telaPequena = true : state.telaPequena = false;
    }, 100);
}

function movimentacaoSeta(pParam: number) {
    selecionarProntuario(props.lstProntuario[pParam], pParam);
    document.getElementById(`prontuario${pParam}`)?.focus();
}

function moverPorSeta(pIndice: number, event?: KeyboardEvent) {
    if (event?.key == "ArrowUp" || event?.key == "ArrowLeft") {
        (pIndice - 1 < 0) ? movimentacaoSeta(props.lstProntuario.length - 1) : movimentacaoSeta(pIndice - 1);
    } else if (event?.key == "ArrowDown" || event?.key == "ArrowRight") {
        (pIndice + 1 > props.lstProntuario.length - 1) ? movimentacaoSeta(0) : movimentacaoSeta(pIndice + 1);
    }
}

async function selecionarProntuario(pParam: any, pIndex: number) {
    let sql = `SELECT ID_CONVENIO FROM AGENDAMENTO WHERE ID_ATENDIMENTO = ${pParam.idAtendimento}`;
    let data = await services.relatorio.ListarSql(sql);
    if (!data.erros) {
        data = await services.convenio.ListarPorId(data.data);
        if (!data.erros) {
            state.agendaLancar.convenio = data.data;
        }
    }
    state.linhaFocada = pIndex;
    // console.log(pParam);
    state.prontuario = pParam;
}

onMounted(() => {
    // console.log(props.prontuario);
    (props.historico) ?
        (props.lstProntuario[0]) ? state.prontuario = props.lstProntuario[0] : state.prontuario.paciente = props.agendaLancar.paciente
        :
        state.prontuario = props.prontuario;

    state.agendaLancar = props.agendaLancar;
    state.mostrarModal = props.mostrarModal;
    // console.log(props.config);
    // setTimeout(() => {
    (props.config.prontCampo1Visible && props.config.prontCampo1.trim() != "") ? state.hdaMedico = props.config.prontCampo1 : "";
    if (props.config.prontCampoUnico == true) {
        state.campoUnico = props.config.prontCampoUnico;
    } else {
        (props.config.prontCampoEnfVisible && props.config.prontCampoEnf.trim() != "") ? state.hdaEnfermagem = props.config.prontCampoEnf : "";
        (props.config.prontCampo2Visible && props.config.prontCampo2.trim() != "") ? state.exameFisico = props.config.prontCampo2 : "";
        (props.config.prontCampo3Visible && props.config.prontCampo3.trim() != "") ? state.diagnostico = props.config.prontCampo3 : "";
        (props.config.prontCampo4Visible && props.config.prontCampo4.trim() != "") ? state.receita = props.config.prontCampo4 : "";
        (props.config.prontCampo5Visible && props.config.prontCampo5.trim() != "") ? state.receitaEspecial = props.config.prontCampo5 : "";
    }
    // }, 500);
    tamanho();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalDorape, {
    title: "Informações Adicionais",
    visible: state.mostrarModal,
    usarFooter: false,
    usarModal: true,
    larguraMaxima: '95%',
    onModalResult: modalResultProntuarios
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("label", _hoisted_2, [
          _createTextVNode("Código "),
          _withDirectives(_createElementVNode("input", {
            class: "form-control",
            disabled: "",
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.prontuario.paciente.id) = $event))
          }, null, 512), [
            [_vModelText, state.prontuario.paciente.id]
          ])
        ]),
        _createElementVNode("label", _hoisted_3, [
          _createTextVNode("Nome "),
          (state.prontuario.paciente.nomeSocial?.trim().length > 0)
            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 0,
                class: "form-control",
                disabled: "",
                type: "text",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.prontuario.paciente.nomeSocial) = $event))
              }, null, 512)), [
                [_vModelText, state.prontuario.paciente.nomeSocial]
              ])
            : _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 1,
                class: "form-control",
                disabled: "",
                type: "text",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((state.prontuario.paciente.nome) = $event))
              }, null, 512)), [
                [_vModelText, state.prontuario.paciente.nome]
              ])
        ]),
        _createElementVNode("label", _hoisted_4, [
          _createTextVNode("Data de Nascimento "),
          _createElementVNode("input", {
            class: "form-control",
            disabled: "",
            type: "text",
            value: __props.retornaDataBR(state.paciente.dtNascimento)
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("label", _hoisted_6, [
          _createTextVNode("Convênio "),
          _createElementVNode("input", {
            class: "form-control",
            type: "text",
            value: state.agendaLancar.convenio.descricao
          }, null, 8, _hoisted_7)
        ])
      ]),
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          (__props.historico == true)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("table", _hoisted_13, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", _hoisted_14, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.colunasAux, (c, index) => {
                          return (_openBlock(), _createElementBlock("th", {
                            key: index,
                            class: _normalizeClass(`linha cabecalho pointer`)
                          }, _toDisplayString(c), 1))
                        }), 128))
                      ])
                    ]),
                    (__props.lstProntuario.length > 0)
                      ? (_openBlock(), _createElementBlock("tbody", _hoisted_15, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.lstProntuario, (p, index) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: index,
                              id: `prontuario${index}`,
                              onClick: ($event: any) => (selecionarProntuario(p, index)),
                              onKeyup: ($event: any) => (moverPorSeta(index, $event)),
                              class: _normalizeClass({ 'table-active fonte': index === state.linhaFocada }),
                              style: { 'cursor': 'default' },
                              tabindex: index + 1
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.linhasAux, (l, index) => {
                                return (_openBlock(), _createElementBlock("td", {
                                  key: index,
                                  class: "linha"
                                }, [
                                  _withDirectives(_createElementVNode("span", null, _toDisplayString(_unref(moment)(p[l]).format('DD/MM/YYYY')), 513), [
                                    [_vShow, typeof p[l] === 'string' && p[l].includes('T00:00:00')]
                                  ]),
                                  (typeof p[l] === 'object' && p[l]?.descricao)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(p[l]?.descricao), 1))
                                    : (typeof p[l] === 'object' && p[l]?.nome)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(p[l]?.nome), 1))
                                      : ((typeof p[l] === 'object'))
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_19, " NÃO INFORMADO "))
                                        : _createCommentVNode("", true),
                                  _withDirectives(_createElementVNode("span", null, _toDisplayString(p[l]), 513), [
                                    [_vShow, (typeof p[l] !== 'string' || !p[l].includes('T00:00:00'))
                                                && !p[l]?.descricao && !p[l]?.nome]
                                  ])
                                ]))
                              }), 128))
                            ], 42, _hoisted_16))
                          }), 128)),
                          _createElementVNode("tr", {
                            tabindex: __props.lstProntuario.length + 1,
                            onKeyup: _cache[3] || (_cache[3] = ($event: any) => (moverPorSeta(__props.lstProntuario.length + 1, $event)))
                          }, null, 40, _hoisted_20)
                        ]))
                      : (_openBlock(), _createElementBlock("tbody", _hoisted_21, _hoisted_23))
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (state.telaPequena == false && __props.historico == true)
            ? (_openBlock(), _createElementBlock("hr", _hoisted_24))
            : _createCommentVNode("", true),
          (state.telaPequena == false)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("label", _hoisted_27, [
                    _createTextVNode("Código "),
                    _withDirectives(_createElementVNode("input", {
                      class: "form-control",
                      type: "text",
                      disabled: "",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((state.prontuario.id) = $event))
                    }, null, 512), [
                      [_vModelText, state.prontuario.id]
                    ])
                  ]),
                  _createElementVNode("label", _hoisted_28, [
                    _createTextVNode("Data "),
                    (state.prontuario.id > 0)
                      ? (_openBlock(), _createElementBlock("input", {
                          key: 0,
                          class: "form-control",
                          type: "text",
                          disabled: "",
                          value: __props.retornaDataBR(state.prontuario.data)
                        }, null, 8, _hoisted_29))
                      : (_openBlock(), _createElementBlock("input", _hoisted_30))
                  ])
                ]),
                _createElementVNode("label", _hoisted_31, [
                  _createTextVNode("Profissional "),
                  _createElementVNode("input", {
                    class: "form-control",
                    type: "text",
                    disabled: "",
                    value: state.prontuario.profissional?.nome
                  }, null, 8, _hoisted_32)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_33, [
          _createElementVNode("ul", _hoisted_34, [
            _createElementVNode("li", _hoisted_35, [
              _createElementVNode("button", {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (trocarPagina(0))),
                class: _normalizeClass(["nav-link", { 'active': state.numeroPagina === 0, 'texto-colorido': state.numeroPagina != 0 }])
              }, _toDisplayString(state.hdaMedico), 3)
            ]),
            _createElementVNode("li", _hoisted_36, [
              (state.campoUnico === false)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (trocarPagina(1))),
                    class: _normalizeClass(["nav-link", { 'active': state.numeroPagina === 1, 'texto-colorido': state.numeroPagina != 1 }])
                  }, _toDisplayString(state.hdaEnfermagem), 3))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("li", _hoisted_37, [
              (state.campoUnico === false)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (trocarPagina(2))),
                    class: _normalizeClass(["nav-link", { 'active': state.numeroPagina === 2, 'texto-colorido': state.numeroPagina != 2 }])
                  }, _toDisplayString(state.exameFisico), 3))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("li", _hoisted_38, [
              (state.campoUnico === false)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (trocarPagina(3))),
                    class: _normalizeClass(["nav-link", { 'active': state.numeroPagina === 3, 'texto-colorido': state.numeroPagina != 3 }])
                  }, _toDisplayString(state.diagnostico), 3))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("li", _hoisted_39, [
              (state.campoUnico === false)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (trocarPagina(4))),
                    class: _normalizeClass(["nav-link", { 'active': state.numeroPagina === 4, 'texto-colorido': state.numeroPagina != 4 }])
                  }, _toDisplayString(state.receita), 3))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("li", _hoisted_40, [
              (state.campoUnico === false)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (trocarPagina(5))),
                    class: _normalizeClass(["nav-link", { 'active': state.numeroPagina === 5, 'texto-colorido': state.numeroPagina != 5 }])
                  }, _toDisplayString(state.receitaEspecial), 3))
                : _createCommentVNode("", true)
            ])
          ]),
          (state.numeroPagina === 0)
            ? (_openBlock(), _createElementBlock("label", {
                key: 0,
                class: _normalizeClass(["col-sm-12 col-md-12 form-label", { 'h-auto': state.campoUnico === false, 'campoUnico': state.campoUnico === true }])
              }, [
                _withDirectives(_createElementVNode("textarea", {
                  disabled: "",
                  class: "form-control h-100 w-100",
                  cols: "1",
                  rows: "8",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((state.prontuario.hda) = $event))
                }, null, 512), [
                  [_vShow, state.campoUnico == false],
                  [_vModelText, state.prontuario.hda]
                ]),
                _withDirectives(_createElementVNode("textarea", {
                  disabled: "",
                  class: "form-control h-100 w-100",
                  cols: "100",
                  rows: "8",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((state.prontuario.hda) = $event))
                }, null, 512), [
                  [_vShow, state.campoUnico == true],
                  [_vModelText, state.prontuario.hda]
                ])
              ], 2))
            : _createCommentVNode("", true),
          (state.numeroPagina === 1 && state.campoUnico === false)
            ? (_openBlock(), _createElementBlock("label", _hoisted_41, [
                _withDirectives(_createElementVNode("textarea", {
                  disabled: "",
                  class: "form-control h-100 w-100",
                  cols: "1",
                  rows: "8",
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((state.prontuario.hdaEnfermagem) = $event))
                }, null, 512), [
                  [_vModelText, state.prontuario.hdaEnfermagem]
                ])
              ]))
            : _createCommentVNode("", true),
          (state.numeroPagina === 2 && state.campoUnico === false)
            ? (_openBlock(), _createElementBlock("label", _hoisted_42, [
                _withDirectives(_createElementVNode("textarea", {
                  disabled: "",
                  class: "form-control h-100 w-100",
                  cols: "1",
                  rows: "8",
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((state.prontuario.exameFisico) = $event))
                }, null, 512), [
                  [_vModelText, state.prontuario.exameFisico]
                ])
              ]))
            : _createCommentVNode("", true),
          (state.numeroPagina === 3 && state.campoUnico === false)
            ? (_openBlock(), _createElementBlock("label", _hoisted_43, [
                _withDirectives(_createElementVNode("textarea", {
                  disabled: "",
                  class: "form-control h-100 w-100",
                  cols: "1",
                  rows: "8",
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((state.prontuario.diagnostico) = $event))
                }, null, 512), [
                  [_vModelText, state.prontuario.diagnostico]
                ])
              ]))
            : _createCommentVNode("", true),
          (state.numeroPagina === 4)
            ? (_openBlock(), _createElementBlock("label", _hoisted_44, [
                _withDirectives(_createElementVNode("textarea", {
                  disabled: "",
                  class: "form-control h-100",
                  cols: "1",
                  rows: "8",
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((state.prontuario.receita) = $event))
                }, null, 512), [
                  [_vModelText, state.prontuario.receita]
                ])
              ]))
            : _createCommentVNode("", true),
          (state.numeroPagina === 5)
            ? (_openBlock(), _createElementBlock("label", _hoisted_45, [
                _withDirectives(_createElementVNode("textarea", {
                  disabled: "",
                  class: "form-control h-100",
                  cols: "1",
                  rows: "8",
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((state.prontuario.receitaEspecial) = $event))
                }, null, 512), [
                  [_vModelText, state.prontuario.receitaEspecial]
                ])
              ]))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("div", _hoisted_46, [
            _createElementVNode("label", _hoisted_47, [
              _createElementVNode("ul", _hoisted_48, [
                _createElementVNode("li", _hoisted_49, [
                  _createElementVNode("span", _hoisted_50, _toDisplayString(state.receita), 1)
                ])
              ]),
              _withDirectives(_createElementVNode("textarea", {
                class: "form-control",
                disabled: "",
                cols: "1",
                rows: "6",
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((state.prontuario.receita) = $event))
              }, null, 512), [
                [_vModelText, state.prontuario.receita]
              ])
            ]),
            _createElementVNode("label", _hoisted_51, [
              _createElementVNode("ul", _hoisted_52, [
                _createElementVNode("li", _hoisted_53, [
                  _createElementVNode("span", _hoisted_54, _toDisplayString(state.receitaEspecial), 1)
                ])
              ]),
              _withDirectives(_createElementVNode("textarea", {
                class: "form-control",
                disabled: "",
                cols: "1",
                rows: "6",
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((state.prontuario.receitaEspecial) = $event))
              }, null, 512), [
                [_vModelText, state.prontuario.receitaEspecial]
              ])
            ])
          ], 512), [
            [_vShow, state.campoUnico === true]
          ])
        ], 512), [
          [_vShow, state.mostrarModal]
        ])
      ]),
      _createElementVNode("div", _hoisted_55, [
        _createElementVNode("button", {
          class: "btn btn-secondary w-100 mx-0",
          onClick: _cache[20] || (_cache[20] = ($event: any) => (modalResultProntuarios()))
        }, "Fechar")
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})